const ACCESS_TOKEN_KEY = 'auth_access_token';
const REFRESH_TOKEN_KEY = 'auth_refresh_token';
const EXPIRES_AT_KEY = 'auth_expires_at';

class TokenManager {
  setTokens(accessToken, refreshToken, expiresInSeconds) {
    const now = Date.now();
    const expiresAt = now + expiresInSeconds * 1000;

    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken || '');
    if (refreshToken) {
      localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    }
    localStorage.setItem(EXPIRES_AT_KEY, String(expiresAt));
  }

  clearTokens() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(EXPIRES_AT_KEY);
  }

  getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  getExpiresAt() {
    const raw = localStorage.getItem(EXPIRES_AT_KEY);
    return raw ? parseInt(raw, 10) : 0;
  }

  isTokenExpired() {
    const expiresAt = this.getExpiresAt();
    if (!expiresAt) return true;
    // Consider token expired slightly before actual time to avoid edge cases
    const now = Date.now();
    return now >= expiresAt - 30_000;
  }

  hasTokens() {
    return !!this.getAccessToken();
  }
}

export default new TokenManager();

